<template>
  <div class="popup" v-show="visible">
      <div class="popup--inner">
          <h2 class="popup--title">
              You sucessfully removed {{resource}}
          </h2>
          <p class="popup--paragraph">
              Deleted {{resourcePlural}} are permanently deleted. You cannot revert this action.
          </p>
          <div class="popup--buttons" v-on:click="close">
              <button class="popup--buttons-item btn btn_grey">
                  OK
              </button>
          </div>
      </div>
  </div>
</template>
<script>
  import Popup from 'vue-popup';
  require('vue-popup/lib/popup.css');
  export default {
      mixins: [Popup],
      props: {
        visible: false,
        resource: '',
        resourcePlural: '',
        modal: {
          default: true
        },
        closeOnClickModal: {
          default: true
        }
      },
      methods: {
        close() {
          this.$parent.okToggle();
        }
      }
    };
</script>


// WEBPACK FOOTER //
// modal_ok.vue?e40e1c80